import React, { useState } from 'react'
import DealsTabs from './DealsTabs'
import DealsList from './DealsList'

const DealsSection = () => {
  const [activeTab, setActiveTab] = useState('ALL');

  return (
    <section className="max-w-[1280px] mx-auto px-5 sm:px-6 py-14">
      <DealsTabs activeTab={activeTab} onTabChange={setActiveTab} />
      <DealsList activeTab={activeTab} />
    </section>
  )
}

export default DealsSection
